<template>
    <div class="">
        <headerfilter pageTitle="Payrolls" @selectedMonth="selectedMonth = $event" @selectedTeam="selectedTeam = $event" @selectedGroup="selectedGroup = $event" @selectedEmpl="selectedEmpl = $event" @dateFrom="dateFrom = $event"/>

        <section class="sm:ml-24 ml-5 mb-10 mt-24 bg-gray-800/80 p-1 px-7 rounded-xl">
            <h1 class="m-5 ml-0 text-white font-bold text-xl">Employees payrolls</h1>
            <div class="mt-5 text-white pb-5">
                <table v-if="sextarSalaries.length>0">
                    <thead>
                        <tr class="bg-gray-400 text-black">
                            <td class="text-left p-1 pl-4 rounded-l-lg">Name</td>
                            <td class="text-left p-1">Team - position</td>
                            <td class="text-left p-1">From</td>
                            <td class="text-left p-1">To</td>
                            <td class="text-left p-1">Salary (with bonus)</td>
                            <td class="text-center p-1">Paid</td>
                            <td class="text-left p-1 rounded-r-lg">Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(salary,index) in sextarSalaries" :key="index" :style="'border-left:6px solid ' + salary.color" :class="index % 2 == 0 ? 'bg-gray-700' : 'bg-gray-600'">
                            <td class="text-left p-2 pl-4">{{salary.userName}}</td>
                            <td class="text-left p-1">{{salary.teamName}} - {{salary.positionName}}</td>
                            <td class="text-left p-1">{{salary.dateFrom}}</td>
                            <td class="text-left p-1">{{salary.dateTo}}</td>
                            <td class="text-left p-1 font-bold">$ {{parseFloat(salary.salary).toFixed(2)}}</td>
                            <td class="text-center p-1"><i :class="salary.paid == 1 ? 'fa-solid fa-check text-green-400' : 'fa-solid fa-xmark text-red-400'"></i></td>
                            <td class="text-left p-1"><button v-if="salary.paid == 0" @click="markAsPaid(salary.id,index)" class="bg-indigo-300 text-black px-2 rounded-lg">Mark as paid</button></td>
                        </tr>
                    </tbody>
                </table>
                <span v-else class="text-white/80">This month has no locked salaries yet. Choose a different month</span>
            </div>
        </section>
    </div>
</template>

<script setup>
    import headerfilter from "@/components/headerFilter.vue";
</script>

<script>
    export default {
        props: ['dateFrom','selectedEmpl','selectedGroup','selectedMonth','selectedTeam'],
        data() {
            return {
                sextarSalaries:[],
                sextingCosts: [],
                mounted:false
            }
        },
        components() {
            headerfilter
        },
        watch: {
            selectedMonth: function(newVal, oldVal) { // watch it
                if (this.mounted) {
                    this.getSalaries();
                }
            },
            selectedGroup: function(newVal, oldVal) { // watch it
                if (this.mounted) {
                    this.getSalaries();
                }
            },
            selectedEmpl: function(newVal, oldVal) { // watch it
                if (this.mounted) {
                    this.loading = true;
                    this.getSalaries();
                }
            },
            selectedTeam: function(newVal, oldVal) { // watch it
                if (this.mounted) {
                    this.loading = true;
                    this.getSalaries();
                }
            },
        },
        methods: {
            markAsPaid(salary_id,salary_index) {
                if (confirm("Mark as paid?")) {
                    axios.patch(baseURL+"finance/", {
                        userToken: this.$cookies.get('userToken'),
                        action:'markAsPaid',
                        salaryID: salary_id,
                        companyID: this.$cookies.get('c_id')
                    }).then((result) => {
                        this.sextarSalaries[salary_index].paid = true;
                    }, (error) => {
                        console.log(error);
                    });
                }
            },
            getSalaries() {
                axios.get(baseURL+"finance/", {
                    params: {
                        userToken: this.$cookies.get('userToken'),
                        build:'sextarSalaries',
                        selectedMonth: this.selectedMonth,
                        companyID: this.$cookies.get('c_id')
                    }
                }).then((result) => {
                    if (result.status == 200) {
                        this.sextarSalaries = result.data;
                    }
                }, (error) => {
                    console.log(error);
                });
            },
        },
        created() {
            if (!(this.$cookies.get('c_id'))) {
                var companyID = null;
            } else {
                var companyID = this.$cookies.get('c_id');
            }
            axios.get(baseURL+"opravnenia/userToken.php", {
                params: {
                    userToken: this.$cookies.get('userToken'),
                    companyID: companyID
                }
                }).then((result) => {
                    if (result.data.selectBranch) {
                        let prev = this.$route.path;
                        this.$router.push({name:'Branches', params: { prevRoute: prev } });
                    } else if ((result.data.logout) && (this.$router.currentRoute._rawValue.fullPath != "/Login")) {
                        this.$cookies.set('userToken','');
                        window.location.href = '/';
                    }
                }, (error) => {
                console.log(error);
            })
        }, 
        mounted() {
            this.mounted = true;
        }
    }
</script>